import { render, staticRenderFns } from "./TenancyDeposit.vue?vue&type=template&id=a06bb600&scoped=true&"
import script from "./TenancyDeposit.vue?vue&type=script&lang=js&"
export * from "./TenancyDeposit.vue?vue&type=script&lang=js&"
import style0 from "./TenancyDeposit.vue?vue&type=style&index=0&id=a06bb600&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06bb600",
  null
  
)

export default component.exports